import React, { Component } from 'react'

import { Button, DropDown, Option } from './styles'

class DropdownButton extends Component {
  constructor() {
    super()
    this.state = {
      visible: false,
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  setVisible = visible => {
    this.setState({ visible })
  }

  handleClick = e => {
    if (
      (this.node && this.node.contains(e.target)) ||
      this.button.contains(e.target)
    ) {
      return
    }

    this.state.visible && this.setState({ visible: false })
  }

  render() {
    const { visible } = this.state
    const {
      content,
      actions,
      right = false,
      noHover,
      dropdownContainerWidth = 0,
    } = this.props

    return (
      <div style={{ position: 'relative' }}>
        <Button
          noHover={noHover}
          type="button"
          onClick={() => this.setVisible(!visible)}
          ref={el => (this.button = el)}
        >
          {content}
        </Button>
        <DropDown
          dropdownContainerWidth={dropdownContainerWidth}
          ref={el => (this.node = el)}
          visible={visible}
          right={right}
        >
          {visible &&
            actions.map((item, index) => (
              <Option key={index} onClick={item.action}>
                {item.label}
              </Option>
            ))}
        </DropDown>
      </div>
    )
  }
}

export default DropdownButton
